import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import ProjectCard from '../projects//Cards';
import NotifyHOC from '../../HOC/Notifications';

import * as tokenService from '@nexxt/common/firebase/auth/userDetails';
import * as clientService from '../../services/client.service';
import * as Action from '../../actions/project.actions';
import * as projectService from '../../services/project.service';
import * as userService from '../../services/user.service';
import * as newsService from '../../services/news.service';
import * as Cookies from 'js-cookie';

import {
    AI_CODING,
    MANAGE_ACCOUNTS,
    PROJECTS,
    PROJECT_SELECTION
} from '../../constants/routes';
import { uppercaseFirstLetter } from '@nexxt/common/services/TextService';
import {
    INCA_DEMO_BOOK_URL,
    INCA_HELP_URLS,
    STATIC_STORAGE_URL
} from '@nexxt/common/constants';
import {
    HealthProblem,
    PanelType,
    Project,
    QuickTagInstanceReference
} from '@nexxt/common/types';
import { alertMessage, parseAlertMessage } from '../../constants/alertMessage';
import { IApplicationState } from '../../reducers';
import { INITIAL_SESSION, PortalSession } from '../../constants/project';
import { PROJECT_EDIT_MODES } from '../../interface/project.interface';
import * as _ from 'lodash';
import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
import { TENANT_LEVEL } from '@nexxt/common/types';
import { UilAngleLeft, UilAngleRight } from '@iconscout/react-unicons';
import config from '../../config';
import axios from 'axios';
import { getQueryString } from '@nexxt/common/services/TextService';
import Fuse from 'fuse.js';
import { ActiveUser } from '../../interface/user.interface';
import { News } from '../../interface/common.interface';
import LinkGeneratorModal from '../projects/LinkGeneratorModal';
import { Paper } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import http from '../../utils/http';
import CodingCard from '../quicktag/CodingCard';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

interface ProjectProps {
    toastNotification: any;
    projects: any[];
    user: any;
    editMode: PROJECT_EDIT_MODES;
    projectHealth: HealthProblem[];
    fetchProjects: () => Promise<any>;
    clearState: () => void;
    checkProjectHealth: (id: number) => Promise<void>;
    clearProjectHealth: () => void;
}

interface ProjectState {
    tenantId: number;
    clientID: number;
    isRequesting: boolean;
    projects: Array<Project>;
    quicktagInstances: Array<QuickTagInstanceReference>;
    filteredProjects: Project[];
    clients: any[];
    selectedFilters: {
        status: any;
        client: any;
        owner: any;
    };
    searchValue: string;
    tenantUsers: any[];
    isDuplicateProject: boolean;
    isShareLinksModalOpen: boolean;
    selectedProject: Project;
    duplicatedProject: any;
    session: PortalSession;
    newRapidSolutions: string[];
    whatsnewIndex: number;
    clientTerm: 'Client' | 'Team/Program';
    currentNewsIdx: number;
    users: ActiveUser[];
    news: News[];
    usefulLinks: News[];
}

class Welcome extends React.Component<ProjectProps, ProjectState> {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            quicktagInstances: [],
            filteredProjects: [],
            clientID: null,
            tenantId: null,
            isRequesting: false,
            selectedFilters: {
                status: null,
                client: null,
                owner: null
            },
            searchValue: '',
            tenantUsers: [],
            clients: [],
            isDuplicateProject: false,
            isShareLinksModalOpen: false,
            selectedProject: null,
            duplicatedProject: {},
            session: INITIAL_SESSION,
            newRapidSolutions: [],
            whatsnewIndex: 0,
            clientTerm: 'Client',
            currentNewsIdx: 0,
            users: [],
            news: [],
            usefulLinks: []
        };
    }

    async componentDidMount() {
        if (getTenantLevel() === TENANT_LEVEL.SELF_SERVICE) {
            this.setState({ clientTerm: 'Team/Program' });
        }
        const tenantId = tokenService.getTenantId();

        this.setState({ tenantId, isRequesting: true }, async () => {
            const promises = [];
            promises.push(this.loadSession);
            promises.push(this.getClients);
            promises.push(this.getProjects);
            promises.push(this.getUsers);
            promises.push(this.getNews);
            promises.push(this.getQuicktagInstances);
            await Promise.all(promises.map((f) => f()));
            this.setState({ isRequesting: false });
            setInterval(() => {
                const nextIdx =
                    this.state.currentNewsIdx == this.state.news.length - 1
                        ? 0
                        : this.state.currentNewsIdx + 1;
                this.setState({ currentNewsIdx: nextIdx });
            }, 20000);
        });
    }

    loadSession = async (): Promise<void> => {
        const featuredRapidSolution = getQueryString('rs');
        try {
            const DATA_API_URL = `${config.host.data}/session/load/portal/${this.props.user.id}`;
            const cssToken = Cookies.get('csst');
            const signal = axios.CancelToken.source();
            const res = await axios.get(DATA_API_URL, {
                cancelToken: signal.token,
                headers: { Authorization: `Bearer ${cssToken}` },
                withCredentials: true
            });

            // apply session if it exists
            if (res.status === 200) {
                const loadedSession = {
                    ...INITIAL_SESSION,
                    ...res.data
                };
                const newRapidSolutions = [];

                if (featuredRapidSolution) {
                    // check if user has seen this rapid solution already
                    loadedSession.featuredRapidSolution = featuredRapidSolution;
                    loadedSession.viewed = false;
                } else {
                    if (
                        !loadedSession.lastLoggedIn ||
                        loadedSession.lastLoggedIn.split('T')[0] !==
                            new Date().toISOString().split('T')[0]
                    ) {
                        // find new rapid solutions not seen by user
                        const newRapidSolutionsToBeAdded = Object.keys(
                            loadedSession.seenRapidSolutions
                        ).filter(
                            (solution) =>
                                loadedSession.seenRapidSolutions[solution] ===
                                    false &&
                                loadedSession.featuredRapidSolution !== solution
                        );
                        // show what's new modal if new rapid solutions
                        // and clear and previous featured rapid solutions
                        if (newRapidSolutionsToBeAdded.length > 0) {
                            newRapidSolutions.push(
                                ...newRapidSolutionsToBeAdded
                            );
                            loadedSession.viewed = false;
                            loadedSession.featuredRapidSolution = null;
                        }
                    }
                }
                this.setState({
                    session: loadedSession,
                    newRapidSolutions: newRapidSolutions
                });
            }
        } catch (error) {
            // if package session doesn't exist, use template session
            // apply featured rapid solution if applicable
            this.setState({
                session: {
                    ...INITIAL_SESSION,
                    featuredRapidSolution: featuredRapidSolution
                        ? featuredRapidSolution
                        : INITIAL_SESSION.featuredRapidSolution
                }
            });
        }
    };

    saveSession = async (newSession): Promise<void> => {
        const DATA_API_URL = `${config.host.data}/session/save`;
        const signal = axios.CancelToken.source();
        const body = {
            sessionKey: this.props.user.id,
            sessionContext: 'portal',
            sessionObject: newSession
        };

        try {
            const cssToken = Cookies.get('csst');
            await axios.post(DATA_API_URL, body, {
                cancelToken: signal.token,
                headers: { Authorization: `Bearer ${cssToken}` },
                withCredentials: true
            });
            this.setState({ session: newSession });
        } catch (error) {
            console.log('ERROR! Could not save session:', error);
        }
    };

    /**
     * Function to get all projects.
     */
    getProjects = async (refresh = false) => {
        try {
            if (!this.props.projects.length || refresh) {
                const response = await this.props.fetchProjects();
                const tenantUsers = _.uniq(
                    response.data.data.map((p) => p.lastModifiedBy)
                ).map((name) => {
                    return { value: name, label: name };
                });
                this.setState({
                    projects: response.data.data,
                    filteredProjects: response.data.data,
                    tenantUsers: tenantUsers
                });
            } else {
                this.setState({
                    projects: this.props.projects,
                    filteredProjects: this.props.projects
                });
            }
        } catch (error) {
            console.error(error);
            this.props.toastNotification.error(
                alertMessage.UNABLE_FETCH_PROJECTS
            );
        }
    };

    /**
     * Function to get quicktag instances list to show in latest quicktag list.
     */
    getQuicktagInstances = async () => {
        try {
            const url = config.api.endpoints.listQuickTagInstances;
            const response = await http.get(url);
            this.setState({
                quicktagInstances: response.data.data
            });
        } catch (err) {
            console.error(err);
        }
    };

    /**
     * Function to get client list to show in client dropdown.
     */
    getClients = async () => {
        try {
            const response = await clientService.fetchClients(
                this.state.tenantId
            );
            this.setState({
                clients: response.data.data
            });
        } catch (error) {
            this.props.toastNotification.error(
                _.template(alertMessage.UNABLE_GET_CLIENT_LIST_t)({
                    clientName: this.state.clientTerm
                })
            );
        }
    };

    /**
     * Function to handle all filters.
     */
    handleFilterSelect = (filterKey, filterValue) => {
        this.setState(
            {
                selectedFilters: {
                    ...this.state.selectedFilters,
                    [filterKey]: filterValue
                }
            },
            this.handleFilter
        );
    };

    /**
     * Function to fetch project without any filter.
     */
    fetchProjects = async () => {
        try {
            const response = await this.props.fetchProjects();
            this.setProjectInState(response);
        } catch (e) {
            throw e;
        }
    };

    setProjectInState = (response) => {
        this.setState({
            projects: response.data.data
        });
    };

    getUsers = async () => {
        try {
            const users = await userService.fetchActiveUsers();
            this.setState({
                users
            });
        } catch (error) {
            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.UNATHORIZED_ACCESS,
                    'Project manager'
                )
            );
        }
    };

    getNews = async () => {
        try {
            const newsItems = await newsService.fetchNews();

            const news = newsItems
                .filter((item) => !item.hidden)
                .sort((a, b) => a.order - b.order);

            const usefulLinks = newsItems
                .filter((item) => item.hidden)
                .sort((a, b) => a.order - b.order);
            this.setState({
                news,
                usefulLinks
            });
        } catch (error) {
            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.UNATHORIZED_ACCESS,
                    'Project manager'
                )
            );
        }
    };

    /**
     * Function to reset filters.
     */
    resetFilters = () => {
        this.setState({
            selectedFilters: { status: null, client: null, owner: null },
            searchValue: ''
        });
        this.getProjects();
    };

    /**
     * Return true if any filter is active.
     */
    isSomeFilterActive = () => {
        return (
            Object.values(this.state.selectedFilters).some((f) => f) ||
            this.state.searchValue.length
        );
    };

    onSearch = (event) => {
        this.setState(
            {
                searchValue: event.target.value
            },
            this.handleFilter
        );
    };

    handleFilter = () => {
        const { selectedFilters, searchValue, projects, users, news } =
            this.state;
        const { owner, status, client } = selectedFilters;
        const isEmptySearch = !searchValue;

        /** Filter by Status / Client / Owner */
        const filteredByDropdown = projects.filter((proj) => {
            const statusMatch =
                !status ||
                status.value === proj.status ||
                status.value === 'ALL';
            const ownerMatch = !owner || owner.value === proj.regBy;
            const clientMatch = !client || client.value === proj.client;

            return statusMatch && ownerMatch && clientMatch;
        });
        let filteredProjects = filteredByDropdown;
        if (!isEmptySearch) {
            const filteredProjectsWithFilterKey = filteredByDropdown.map(
                (p) => ({ ...p, searchKey: `${p.name} ${p.codeName} ${p.id}` })
            );
            const searchOptions = {
                includeMatches: true,
                includeScore: true,
                ignoreLocation: true,
                keys: ['name', 'codeName', 'id'],
                threshold: 0,
                sortFn: (a, b) => b.lastModifiedOn - a.lastModifiedOn
            };

            const fuse = new Fuse(filteredProjectsWithFilterKey, searchOptions);
            filteredProjects = fuse
                .search(searchValue)
                .map((search) => search.item);
        }

        this.setState({ filteredProjects });
    };

    clearProject = () => {
        this.props.clearState();
    };

    clearState = (callback = () => {}) => {
        this.setState(
            {
                selectedFilters: { status: null, client: null, owner: null },
                clientID: null
            },
            callback
        );
    };

    duplicateProjectToggle = async () => {
        this.setState({
            isDuplicateProject: !this.state.isDuplicateProject
        });
    };

    setDuplicateProject = (project) => {
        this.setState({
            duplicatedProject: project
        });
    };

    createDuplicateProject = async (values: any, { setSubmitting }) => {
        this.setState({
            isRequesting: true
        });

        const { duplicatedProject } = this.state;
        try {
            await projectService.duplicateProject(duplicatedProject.id, {
                name: values.projectName
            });
            this.getProjects(true);
            this.props.toastNotification.success(
                parseAlertMessage(
                    alertMessage.SUCCESS_DUPLIATE_PROJECT,
                    uppercaseFirstLetter(duplicatedProject.name)
                )
            );
            this.duplicateProjectToggle();
            setSubmitting(false);
        } catch (err) {
            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.UNABLE_DUPLICATE_PROJECT,
                    uppercaseFirstLetter(duplicatedProject.name)
                )
            );
            this.getProjects();
            setSubmitting(false);
        }
    };

    toggleShareLinkModal = (project?) => {
        this.setState({
            isShareLinksModalOpen: !this.state.isShareLinksModalOpen,
            selectedProject: project ? project : null
        });
    };

    redirectToProjectSelect = async (solution) => {
        try {
            await this.saveSession({
                ...this.state.session,
                seenRapidSolutions: {
                    ...this.state.session.seenRapidSolutions,
                    [solution.rapidSolutionID]: true
                },
                viewed: true,
                lastLoggedIn: new Date()
            });
            window.location.assign(`/projects/new/select`);
        } catch (err) {
            console.log(err);
        }
    };
    handleStepChange = (step) => this.setState({ currentNewsIdx: step });

    render() {
        const {
            filteredProjects,
            currentNewsIdx,
            news,
            users,
            usefulLinks,
            quicktagInstances,
            isRequesting
        } = this.state;
        const tenantLevel = getTenantLevel();
        const isWizard = tenantLevel === TENANT_LEVEL.INCA_WIZARD;
        const hasProjects =
            filteredProjects &&
            filteredProjects.filter((proj) => proj.tenantID !== -1).length > 0;
        const hasQuicktagInstances =
            quicktagInstances && quicktagInstances.length > 0;

        return (
            <div className="grid grid-cols-12 gap-4">
                {this.state.isShareLinksModalOpen && (
                    <LinkGeneratorModal
                        onClose={this.toggleShareLinkModal}
                        project={this.state.selectedProject}
                        user={this.props.user}
                        hidePanel={
                            this.state.selectedProject.panelSettings
                                ?.panelType === PanelType.INCA
                        }
                        isWizard={isWizard}
                    />
                )}

                <div className="bg-white rounded-lg p-3 col-span-8">
                    <div className="grid grid-cols-12 gap-4 h-full">
                        <div className="col-span-8 flex flex-col gap-2 h-full">
                            <AutoPlaySwipeableViews
                                axis={'x'}
                                index={currentNewsIdx}
                                onChangeIndex={this.handleStepChange}
                                interval={10000}
                                enableMouseEvents
                                style={{ height: '100%' }}
                                containerStyle={{ height: '100%' }}
                            >
                                {news.map((item, i) => (
                                    <div
                                        key={item.title}
                                        className="relative h-full w-full rounded-lg overflow-hidden"
                                    >
                                        <img
                                            className="object-cover h-full w-full"
                                            src={item.imageUrl}
                                        />
                                        <div className="absolute inset-x-0 bottom-0 p-3 pt-1 text-white bg-black/60">
                                            <span className="font-bold text-lg">
                                                {item.title}
                                            </span>
                                            <p className="mb-0">
                                                {item.content + ' '}

                                                {item.moreText && (
                                                    <a
                                                        href={item.moreUrl}
                                                        className="hover:no-underline mt-2"
                                                    >
                                                        {item.moreText}
                                                    </a>
                                                )}
                                            </p>
                                        </div>
                                        <div
                                            onClick={() =>
                                                this.handleStepChange(
                                                    currentNewsIdx !== 0
                                                        ? currentNewsIdx - 1
                                                        : news.length - 1
                                                )
                                            }
                                            className="z-10 cursor-pointer absolute inset-y-0 left-0 p-2 flex items-center hover:bg-gradient-to-r from-black/50 to-black/10 text-gray-400 hover:text-white"
                                        >
                                            <UilAngleLeft size={20} />
                                        </div>
                                        <div
                                            onClick={() =>
                                                this.handleStepChange(
                                                    currentNewsIdx !==
                                                        news.length - 1
                                                        ? currentNewsIdx + 1
                                                        : 0
                                                )
                                            }
                                            className="z-10 cursor-pointer absolute inset-y-0 right-0 p-2 flex items-center hover:bg-gradient-to-l from-black/50 to-black/10 text-gray-400 hover:text-white"
                                        >
                                            <UilAngleRight size={20} />
                                        </div>
                                    </div>
                                ))}
                            </AutoPlaySwipeableViews>
                        </div>
                        <div className="col-span-4 flex flex-col gap-2 text-lg">
                            <span className="font-semibold text-lg leading-none px-2 mb-2">
                                Useful Links
                            </span>
                            {usefulLinks.map((item, i) => {
                                // const isActive = i == currentNewsIdx;
                                return (
                                    <a
                                        key={i}
                                        className={`rounded px-2 py-1 hover:bg-blue hover:bg-opacity-25 hover:no-underline text-inherit hover:text-inherit`}
                                        href={item.moreUrl}
                                    >
                                        {item.linkText}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="col-span-4 flex flex-col gap-4">
                    <div className="bg-white rounded-lg p-3 flex-grow flex flex-col gap-2">
                        <span className="font-semibold text-lg leading-none mb-2">
                            Account Members
                        </span>
                        <div className="grid grid-cols-2 gap-2 h-20">
                            {this.state.users
                                .sort((a, b) => b.id - a.id)
                                .slice(0, 6)
                                .map((user, i) => (
                                    <div
                                        key={i}
                                        className="flex flex-row items-center h-5"
                                    >
                                        <img
                                            className="w-5 h-5 rounded-full mr-2"
                                            src={
                                                user.profilePicture ||
                                                `${STATIC_STORAGE_URL}/img/inca_black.png`
                                            }
                                        />
                                        <span>
                                            {user.firstName} {user.lastName}
                                        </span>
                                    </div>
                                ))}
                        </div>
                        <span>
                            {this.state.users.length > 3 && (
                                <div>{`And ${
                                    this.state.users.length - 4
                                } other members in your account...`}</div>
                            )}
                        </span>

                        <Link
                            to={MANAGE_ACCOUNTS}
                            className="btn btn--sm btn--blue w-max mt-auto"
                        >
                            Invite New Team Members
                        </Link>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex flex-col gap-2">
                        <span className="font-semibold text-lg leading-none">
                            Need Help?
                        </span>
                        <span>
                            Refer to self-guided training materials or reach out
                            with further questions
                        </span>
                        <div className="flex gap-2 mt-auto">
                            <a
                                href={INCA_HELP_URLS['DEFAULT']}
                                className="btn btn--sm btn--blue w-max"
                            >
                                Help Desk
                            </a>
                            <a
                                href={
                                    'mailto:letschat@nexxt.in?subject=Inquiries from inca Platform'
                                }
                                className="btn btn--sm btn--blue w-max"
                            >
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 flex flex-col">
                    <div className="font-bold text-2xl mb-3 mt-2 flex items-baseline gap-4">
                        <span>Latest Projects</span>{' '}
                        {hasProjects && (
                            <Link
                                to={PROJECTS}
                                className="font-semibold text-sm text-blue cursor-pointer hover:no-underline"
                            >
                                See all Projects | Add New
                            </Link>
                        )}
                    </div>
                    <div className="grid grid-cols-4 gap-3">
                        {hasProjects ? (
                            filteredProjects
                                .filter((project) => project.tenantID !== -1)
                                .slice(0, 4)
                                .map((project, index) => {
                                    return (
                                        <ProjectCard
                                            showWatermark
                                            allProjects={this.state.projects}
                                            project={project}
                                            key={index}
                                            getProjects={this.getProjects}
                                            tenantId={this.state.tenantId}
                                            clearState={this.clearState}
                                            duplicateProjectToggle={
                                                this.duplicateProjectToggle
                                            }
                                            setDuplicateProject={
                                                this.setDuplicateProject
                                            }
                                            toggleShareLinkModal={
                                                this.toggleShareLinkModal
                                            }
                                            isShareLinksModalOpen={
                                                this.state.isShareLinksModalOpen
                                            }
                                            cardType="simple"
                                        />
                                    );
                                })
                        ) : !isRequesting ? (
                            <div>
                                <div className="mb-2">
                                    {`Build your first conversational chat experience on the inca platform with AI probing and more!`}
                                </div>
                                <Link
                                    to={PROJECT_SELECTION}
                                    className="btn btn--sm btn--blue w-max mt-auto"
                                >
                                    Create a new Project
                                </Link>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="col-span-12">
                    <div className="font-bold text-2xl mb-3 mt-2 flex items-baseline gap-4">
                        <span>Latest AI Coding</span>
                        {hasQuicktagInstances && (
                            <Link
                                to={AI_CODING}
                                className="font-semibold text-sm text-blue cursor-pointer hover:no-underline"
                            >
                                See all AI Coding | Add New
                            </Link>
                        )}
                    </div>
                    <div className="grid grid-cols-4 gap-3">
                        {hasQuicktagInstances ? (
                            quicktagInstances
                                .sort(
                                    (a, b) =>
                                        b.QuickTagInstanceID -
                                        a.QuickTagInstanceID
                                )
                                .slice(0, 4)
                                .map((project, index) => {
                                    return (
                                        <CodingCard
                                            key={index}
                                            project={project}
                                            cardType="simple"
                                            showWatermark
                                        />
                                    );
                                })
                        ) : !isRequesting ? (
                            <div>
                                <div className="mb-2">
                                    {`Get your open ended verbatims
                                    coded now by going to your AI coding
                                    directory and uploading your verbatims.`}
                                </div>
                                <Link
                                    to={AI_CODING}
                                    className="btn btn--sm btn--blue w-max mt-auto"
                                >
                                    Get started with AI Coding
                                </Link>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { projects, editMode, projectHealth },
        authReducer: { user }
    } = store;
    return {
        projects,
        user,
        editMode,
        projectHealth
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchProjects: () => dispatch(projectService.fetchProjects()),
    clearState: () => {
        dispatch(Action.clearProjects());
    },
    clearProjectHealth: () => dispatch(Action.clearProjectHealth()),
    checkProjectHealth: (projectID: number) =>
        dispatch(projectService.checkProjectHealth(projectID))
});

export default NotifyHOC(connect(mapStateToProps, mapDispatchToProps)(Welcome));
